import * as React from 'react'
import { getPlanOptions } from './PlanCards'

const PLAN_KEYS = ['basic', 'advanced', 'premium']

// Which plan row and billing period are selected on /upgrade, starting from
// the ?plan= / ?period= the visitor arrived with.
export function usePlanSelection({
    requestedPlan,
    requestedPeriod,
    currentPlanId,
    planPrices,
}) {
    const [period, setPeriod] = React.useState(
        requestedPeriod === 'monthly' ? 'monthly' : 'annual'
    )
    const [selectedKey, setSelectedKey] = React.useState(
        PLAN_KEYS.includes(requestedPlan) ? requestedPlan : 'advanced'
    )

    // A paying visitor lands on the period their current plan is billed on, so
    // the "Current" badge sits on the right row.
    React.useEffect(() => {
        if (!currentPlanId || requestedPeriod) return
        setPeriod(/annual/i.test(currentPlanId) ? 'annual' : 'monthly')
    }, [currentPlanId, requestedPeriod])

    const options = React.useMemo(() => getPlanOptions(period, planPrices), [
        period,
        planPrices,
    ])
    const selectedPlan = options.find(option => option.key === selectedKey)
    const saving = React.useMemo(
        () =>
            getPlanOptions('annual', planPrices).find(
                option => option.key === selectedKey
            )?.saving,
        [planPrices, selectedKey]
    )
    const optionFor = (key, forPeriod) =>
        getPlanOptions(forPeriod, planPrices).find(option => option.key === key)

    return {
        period,
        setPeriod,
        selectedKey,
        setSelectedKey,
        options,
        selectedPlan,
        saving,
        optionFor,
    }
}
